import { i18n } from '@ecg-marktplaats/js-react-i18n';
import { fr as dateLocale } from 'date-fns/locale/fr';
import translation from '../../../../locales/fr-BE/translation.json';
import common from '../../../../locales/fr-BE/common.json';
import reviewsDialogUi from '@ecg-internal/reviews-dialog-ui/locales/fr-BE.json';

export default i18n.init({
  lng: 'fr-BE',
  dateLocale,
  translations: {
    translation,
    common,
    reviewsDialogUi,
  },
});
